import { useTranslations } from 'contexts/Translation'
import { HeaderBreadcrumbs, Spinner } from 'components'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams, useHistory } from 'react-router-dom'
import { CustomerProfileAdvancedView } from 'domains/CustomerProfile/components'
import { EditOutlined } from '@ant-design/icons'
import { Button } from '@qonsoll/react-design'

const CustomerProfileShow = (props) => {
  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const params = useParams()

  // [COMPONENT_STATE_HOOKS]

  // [COMPUTED_PROPERTIES]
  const headingProps = {
    title: t('Customer profile show'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }
  const { customerProfileId } = params

  // [HANDLERS]
  const handleBackButtonClick = () => history.goBack()

  return (
    <PageWrapper
      action={
        <Button
          icon={<EditOutlined />}
          onClick={() => history.push(`${customerProfileId}/edit`)}>
          {t('Edit')}
        </Button>
      }
      headingProps={headingProps}>
      <Row noGutters>
        <Col>
          <CustomerProfileAdvancedView />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default CustomerProfileShow
